export default "__VITE_PUBLIC_ASSET__d8dfb72c__"